import styled from 'styled-components';
import { BATTLESHIP, KOALA } from 'visitor-ui-component-library/constants/WidgetColors';
import SearchInput from './SearchInput';
import VizExIcon from 'visitor-ui-component-library/icon/VizExIcon';
import SVGLeft from 'visitor-ui-component-library-icons/icons/SVGLeft';
import VizExIconButton from 'visitor-ui-component-library/button/VizExIconButton';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SearchBoxWrapper = styled.div.withConfig({
  displayName: "SearchBox__SearchBoxWrapper",
  componentId: "sc-1ryg9ob-0"
})(["display:flex;gap:4px;padding:16px;background-color:", ";border-bottom:1px solid ", ";justify-content:center;"], KOALA, BATTLESHIP);
const GoBackIcon = styled(VizExIcon).withConfig({
  displayName: "SearchBox__GoBackIcon",
  componentId: "sc-1ryg9ob-1"
})(["color:", ";"], ({
  theme
}) => theme.colors.primary);
export default function SearchBox({
  searchTerm,
  setSearchTerm,
  disabled,
  updateSearchMode,
  isOnSearchMode
}) {
  const handleInputChange = input => {
    if (input && !isOnSearchMode) {
      updateSearchMode(true);
    }
    setSearchTerm(input);
  };
  return /*#__PURE__*/_jsxs(SearchBoxWrapper, {
    children: [isOnSearchMode && /*#__PURE__*/_jsx(VizExIconButton, {
      onClick: () => {
        updateSearchMode(false);
      },
      size: "md",
      use: "transparent-on-background",
      "aria-label": I18n.text('conversations-visitor-experience-components.knowledgeBase.kbArticle.backToKB'),
      children: /*#__PURE__*/_jsx(GoBackIcon, {
        "aria-hidden": "true",
        icon: /*#__PURE__*/_jsx(SVGLeft, {})
      })
    }), /*#__PURE__*/_jsx(SearchInput, {
      disabled: disabled,
      value: searchTerm,
      onChange: handleInputChange,
      updateSearchMode: updateSearchMode,
      isOnSearchMode: isOnSearchMode
    })]
  });
}
SearchBox.displayName = 'SearchBox';